import { useEffect, useRef, useState } from 'react';

export const useIdleSubscriptionTime = (whenPopupWasShown, isVisible) => {
  const [timeInMinutesSinceLastPopup, setTimeInMinutesSinceLastPopup] = useState<number>(
    (Date.now() - whenPopupWasShown) / 1000 / 60,
  );
  const isEnoughTimeSinceLastPopup = timeInMinutesSinceLastPopup > 5;

  const timeoutRef = useRef<NodeJS.Timeout>();

  const setTime = () => {
    const time = (Date.now() - whenPopupWasShown) / 1000 / 60;
    setTimeInMinutesSinceLastPopup(time);

    if (!isEnoughTimeSinceLastPopup) {
      timeoutRef.current = setTimeout(setTime, 1000 * 10);
    }
  };

  useEffect(() => {
    if (!isVisible) {
      setTime();
    }

    return () => {
      clearTimeout(timeoutRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVisible, whenPopupWasShown]);

  return Boolean(isEnoughTimeSinceLastPopup);
};
